export default function ConsentSection() {
  const handleUnderstand = () => {
    alert('Thank you for reviewing our privacy policy!');
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-3xl mx-auto px-6">
        <div className="bg-[#F4E8D8] rounded-2xl p-12 text-center">
          <div className="w-20 h-20 rounded-full bg-[#F5A962] flex items-center justify-center mx-auto mb-6">
            <i className="ri-shield-check-line text-4xl text-white"></i>
          </div>
          
          <h2 className="text-4xl font-serif font-bold text-gray-900 mb-4">
            We Value Your Privacy
          </h2>
          
          <p className="text-gray-600 leading-relaxed mb-8 max-w-2xl mx-auto">
            This privacy policy outlines how Next Phase Logistics LLC collects, uses, and protects your personal information. We are committed to maintaining the highest standards of data security and transparency. Last updated: February 2024.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              onClick={handleUnderstand}
              className="px-8 py-3 bg-[#E67E50] text-white text-sm font-semibold rounded-full hover:bg-[#3D2817] transition-colors cursor-pointer whitespace-nowrap"
            >
              I Understand
            </button>
            <button className="px-8 py-3 bg-transparent border-2 border-[#E67E50] text-[#E67E50] text-sm font-semibold rounded-full hover:bg-[#E67E50] hover:text-white transition-colors cursor-pointer whitespace-nowrap">
              Download PDF
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
